import { type EntityV3Req, EntityV3Type } from '@revelio/data-access';

import {
  type Filter,
  FilterId,
  FilterType,
  type TreeFilter,
} from '../types/filters';

export const getCompanySummaryFilters = (
  filters: Filter[]
): EntityV3Req | null => {
  const selectedPrimaryFilter = (
    filters.find((filter) => filter.id === FilterId.COMPANY) as TreeFilter
  )?.primarySelections?.[0];
  const selectedCompanyRCID =
    selectedPrimaryFilter?.id?.split('_').pop() || selectedPrimaryFilter?.id;

  if (!selectedCompanyRCID) return null;

  return {
    entID: Number(selectedCompanyRCID),
    entType: EntityV3Type.Company,
    numCompetitors: 7,
  };
};

export const getRoleSummaryFilters = (
  filters: Filter[]
): EntityV3Req | null => {
  const primaryFilter = filters.find((filter) => filter.id === FilterId.ROLE);

  if (primaryFilter?.type !== FilterType.TREE) return null;

  const selectedPrimaryFilter = primaryFilter?.primarySelections?.[0];

  if (!selectedPrimaryFilter) return null;

  const entType = (() => {
    switch (selectedPrimaryFilter.levelId) {
      case 'role_k7':
        return EntityV3Type.RoleK7;
      case 'role_k150':
        return EntityV3Type.RoleK150;
      case 'role_k1500':
        return EntityV3Type.RoleK1500;
      case 'role_k15000':
        return EntityV3Type.RoleK15000;
      default:
        return null;
    }
  })();

  if (!entType) return null;

  return {
    entID: Number(
      selectedPrimaryFilter.id.split('_').pop() || selectedPrimaryFilter.id
    ),
    entType,
  };
};
